var _path, _path2, _path3, _path4, _path5, _path6, _path7;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMotionAndGraphicsIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 33,
    viewBox: "0 0 42 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1 32L41 32",
    stroke: "white",
    strokeLinecap: "round",
    strokeDasharray: "3 3"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1 4.00004L30.5 4",
    stroke: "white",
    strokeLinecap: "round",
    strokeDasharray: "3 3"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M41 9L41 32",
    stroke: "white",
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M0.999999 4L1.00001 32",
    stroke: "white",
    strokeLinecap: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M39.4948 2.83907L33.2539 6.25781M38.9887 0.99872C39.2571 0.99872 39.5146 1.10261 39.7044 1.28754C39.8941 1.47246 40.0008 1.72328 40.0008 1.9848C40.0008 2.24632 39.8941 2.49714 39.7044 2.68206C39.5146 2.86699 39.2571 2.97088 38.9887 2.97088C38.7203 2.97088 38.4629 2.86699 38.2731 2.68206C38.0833 2.49714 37.9767 2.24632 37.9767 1.9848C37.9767 1.72328 38.0833 1.47246 38.2731 1.28754C38.4629 1.10261 38.7203 0.99872 38.9887 0.99872Z",
    stroke: "white",
    strokeLinecap: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M39.2408 5.21171L33 1.79297M39.4504 6.76325C39.2607 6.94817 39.0032 7.05206 38.7348 7.05206C38.4664 7.05206 38.209 6.94817 38.0192 6.76325C37.8294 6.57832 37.7228 6.32751 37.7228 6.06598C37.7228 5.80446 37.8294 5.55364 38.0192 5.36872C38.209 5.18379 38.4664 5.0799 38.7348 5.0799",
    stroke: "white",
    strokeLinecap: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M27.25 16.567C27.5833 16.7594 27.5833 17.2406 27.25 17.433L15.25 24.3612C14.9167 24.5537 14.5 24.3131 14.5 23.9282L14.5 10.0718C14.5 9.6869 14.9167 9.44633 15.25 9.63878L27.25 16.567Z",
    stroke: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMotionAndGraphicsIcon);
export default __webpack_public_path__ + "static/media/MotionAndGraphicsIcon.05f319381f9f9d51c90e702b7469798c.svg";
export { ForwardRef as ReactComponent };